import { createContext } from 'react';

type TClientContext = {
  filteredQrBrand: string | null;
  filteredQrMultiBrands: string[] | null;
  filteredQrCity: string | null;
  filteredQrDealer: string | null;
};

export const ClientContext = createContext<TClientContext>({
  filteredQrBrand: null,
  filteredQrMultiBrands: null,
  filteredQrCity: null,
  filteredQrDealer: null
});
